<template>
  <v-form>
    <v-container fluid>
      <v-card elevation="12" class="pa-10">
        <v-row>
          <v-col>
            <h2>Grupo Químico - FRAC</h2>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="2">
            <v-subheader>Nome do Grupo</v-subheader>
          </v-col>
          <v-col class="d-flex" cols="3">
            <v-select
              :items="nome_grupos"
              v-model="grupo_quimico.id_nome_grupo"
              item-text="nome_grupo"
              item-value="id"
              label="Nome do Grupo"
              dense
              outlined
              no-data-text="Adicione um Nome do Grupo para selecionar"
            ></v-select>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="2">
            <v-subheader>Grupo Químico</v-subheader>
          </v-col>
          <v-col class="d-flex" cols="3">
            <v-text-field
              v-model="grupo_quimico.grupo_quimico"
              :rules="fieldRequired"
              label="Grupo Químico"
              dense
              outlined
              required
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-btn dark style="margin-left: 5px; margin-top: 2px" color="green" @click="salvar">
              Salvar
            </v-btn>
            <v-btn
              style="margin-left: 5px; margin-top: 2px"
              color="gray"
              to="/frac/grupo-quimico"
            >
              Cancelar
            </v-btn>
          </v-col>
        </v-row>
      </v-card>
    </v-container>
    <v-overlay :value="overlay">
      <v-progress-circular
        indeterminate
        size="64"
      ></v-progress-circular>
    </v-overlay>
    <v-snackbar
      v-model="snackbar"
      timeout="2000"
    >
      {{ aviso }}

      <template v-slot:action="{ attrs }">
        <v-btn
          color="blue"
          text
          v-bind="attrs"
          @click="snackbar = false"
        >
          Fechar
        </v-btn>
      </template>
    </v-snackbar>
  </v-form>
</template>

<script>
import { BASE_URL } from '../../util/constants';
export default {
  data: () => ({
    url: "https://apiadmin.allgeconsultoria.com/index.php/frac/",
    overlay: false,
    snackbar: false,
    aviso: '',
    nome_grupos: [],
    grupo_quimico: {
      id: "",
      id_nome_grupo: '',
      grupo_quimico: '',
    },
    fieldRequired: [(v) => !!v || "Campo Obrigatorio"],
  }),
  created() {
    this.url = `${BASE_URL}frac/`;
    this.initialize();
  },
  methods: {
    async initialize() {
      await this.fetchNomeGrupos();

      if (this.$route.params.id !== "") {
        await this.fetchGrupoQuimico(this.$route.params.id);
      }
    },
    async fetchNomeGrupos() {
      try {
        let response = await fetch(`${this.url}nome-grupo`);
        response = await response.json();
        this.nome_grupos = response.map(item => ({id: item.id, nome_grupo: item.nome_grupo})).filter(item => item.nome_grupo !== "").sort((a, b) => a.nome_grupo > b.nome_grupo ? 1 : -1);
      } catch (error) {
        this.nome_grupos = [];
      }
    },
    async fetchGrupoQuimico(id) {
      try {
        let response = await fetch(`${this.url}grupo-quimico/${id}`);
        response = await response.json();
        this.grupo_quimico = response;
      } catch (error) {
        this.grupo_quimico = {
          id: "",
          id_nome_grupo: '',
          grupo_quimico: '',
        };
      }
    },
    async salvar() {
      this.overlay = true;
      let myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

      let urlencoded = new URLSearchParams();
      urlencoded.append("grupo_quimico", this.grupo_quimico.grupo_quimico);
      urlencoded.append("id_nome_grupo", this.grupo_quimico.id_nome_grupo);
      let method = (this.grupo_quimico.id === '' ? 'POST' : 'PUT')
      
      let requestOptions = {
        method: method,
        headers: myHeaders,
        body: urlencoded,
      };

      fetch(`${this.url}grupo-quimico/${this.grupo_quimico.id}`, requestOptions)
        .then(response => response.json())
        .then(result => {
          console.log(result)
          this.overlay = false;
          this.aviso = 'Salvo com Sucesso';
          this.snackbar = true;
          setTimeout(() => this.$router.push(`/frac/grupo-quimico/`), 1000)
        })
        .catch(error => {
          console.log(error)
          this.overlay = false;
          this.aviso = 'Problema ao Salvar, entre em contato com o suporte';
          this.snackbar = true;
        });
    }
  },
};
</script>
